import React from 'react';

const Modal = ({ children, show, type }) => {
  // Determine the CSS class for the modal based on the type and visibility status
  // 'warn-modal' is used for warning modals when `type` is "warn" and `show` is true
  // Default modal is either visible ('modal d-block') or hidden ('modal d-none') based on `show`
  const modalClass = type === "warn" && show ? 'warn-modal' : show ? 'modal d-block' : 'modal d-none';

  return (
    // Modal container with dynamic class to control appearance
    <div className={modalClass}>
      {/* Render any child elements passed into the Modal */}
      {children}  
    </div>
  );
};

export default Modal;
